import controller from './search.controller';

const template = require('./search.html');

export default {
    bindings: {
        onSearchResult: '&',
        onSaveView: '&',
        onCloseSideNav: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/search.component.js